module.exports = __webpack_public_path__ + "static/media/gcdef_10032.91510599.ico";